import {
  ANNOUNCEMENT_LIVE_SLOT,
  isAnnouncementScheduleActive,
  parseAnnouncementTone,
  type LayoutBlock,
} from '@web-studio/shared-schemas';
import { LUCIDE_SSR_BY_ICON_KEY, resolveSectionSsrIcon } from '../icons/lucideSsrIconNodes';
import { renderLucideIconHtml } from '../icons/renderIconHtml';
import { pickBlockField } from '../lib/localized';
import { escapeHtml } from './escape';

const MESSAGE_SSR = LUCIDE_SSR_BY_ICON_KEY.MessageSquare!;

export function renderAnnouncementBarHtml(block: LayoutBlock, locale: string): string {
  if (block.hidden === true) {
    return '';
  }
  const message = pickBlockField(block.content, 'message', locale).trim();
  if (!message) {
    return '';
  }
  const startsAt = pickBlockField(block.content, 'startsAt', locale).trim();
  const endsAt = pickBlockField(block.content, 'endsAt', locale).trim();
  /* Bake always includes the slot when Visible + message — schedule gate at serve/client. */
  const tone = parseAnnouncementTone(pickBlockField(block.content, 'tone', locale));
  const ctaLabel = pickBlockField(block.content, 'ctaLabel', locale).trim();
  const ctaHref = pickBlockField(block.content, 'ctaHref', locale).trim();
  const sectionIcon = resolveSectionSsrIcon(
    pickBlockField(block.content, 'sectionIcon', locale),
    MESSAGE_SSR,
  );
  const iconHtml = renderLucideIconHtml(sectionIcon.iconNode, {
    size: 'md',
    className: 'ws-announce__icon',
    name: sectionIcon.name,
  });
  const ctaHtml =
    ctaLabel && ctaHref
      ? `<a class="ws-announce__cta" href="${escapeHtml(ctaHref)}">${escapeHtml(ctaLabel)}</a>`
      : ctaLabel
        ? `<span class="ws-announce__cta">${escapeHtml(ctaLabel)}</span>`
        : '';
  const scheduleAttrs = [
    startsAt ? ` data-starts-at="${escapeHtml(startsAt)}"` : '',
    endsAt ? ` data-ends-at="${escapeHtml(endsAt)}"` : '',
  ].join('');
  const outside = isAnnouncementScheduleActive(startsAt, endsAt) ? '' : ' hidden';

  return `<aside class="ws-float-chrome ws-announce ws-announce--${escapeHtml(tone)}" data-block-id="${escapeHtml(block.blockId)}" data-component="Announcement_Bar" data-live-slot="${ANNOUNCEMENT_LIVE_SLOT}" data-announce-tone="${escapeHtml(tone)}" data-ws-announce${scheduleAttrs} role="region" aria-label="${escapeHtml(message)}"${outside}>
  <div class="ws-announce__inner">
    <span class="ws-announce__icon-hit">${iconHtml}</span>
    <p class="ws-announce__message">${escapeHtml(message)}</p>
    ${ctaHtml}
  </div>
</aside>`;
}
